import type { ModuleFile } from '../../core/modules.ts';
export const manifests:ModuleFile['manifests']=[{id:'improvements',title:'Mejoras',path:'mejoras',nav:{group:'Canal',label:'Mejoras',icon:'◎',order:3.5},load:()=>import('./ImprovementsPage.tsx').then(m=>({default:m.ImprovementsPage}))}];
